module.exports = __webpack_public_path__ + "img/blog-list-view-light.4b8c45f4.png";